export default "/images/vendor/flag-icon-css/flags/4x3/nz.svg?c13a64ec70248ccc41d6f5105b52c3d3";